// Divergências · ciclo PDCA (aberta → em_apuracao → resolvida) + foto + WhatsApp
import { db } from '../client.js';
import { escapeHTML, DT, DATE, NUM, QTY, SHORT } from '../shared.js';

export async function viewDivergencias($c) {
  $c.innerHTML = `
    <header class="page-head">
      <div>
        <div class="kicker">EXCEÇÕES PDCA</div>
        <h1>Divergências <strong>e ciclo</strong></h1>
        <p class="lead">Toda exceção operacional vira divergência. Ciclo PDCA: aberta → em_apuracao → resolvida. Causa raiz + ação corretiva obrigatórios. Sem isso, divergência vira cultura.</p>
      </div>
      <div class="page-head-actions">
        <button class="btn btn-blue" id="btn-nova-div">+ Nova divergência</button>
      </div>
    </header>

    <div class="stats" id="div-stats"></div>

    <div class="card">
      <div class="card-head">
        <h2>Divergências <span class="count" id="div-count">…</span></h2>
        <div class="row gap-sm">
          <select id="div-filter">
            <option value="abertas">apenas abertas + em apuração</option>
            <option value="todas">todas</option>
            <option value="aberta">só abertas</option>
            <option value="em_apuracao">só em apuração</option>
            <option value="resolvida">só resolvidas</option>
          </select>
        </div>
      </div>
      <div id="div-list"></div>
    </div>

    <div class="card mt-md" id="div-form-card" style="display:none;">
      <div class="card-head"><h2 id="div-form-title">Nova divergência</h2>
        <button class="btn-mini" id="btn-close-div-form">×</button>
      </div>
      <div id="div-form-body"></div>
    </div>

    <div class="grid-2 mt-md">
      <div class="card">
        <div class="card-head"><h2>Origens recentes</h2></div>
        <div id="div-origins"></div>
      </div>
      <div class="card">
        <div class="card-head"><h2>Bot WhatsApp · status</h2></div>
        <p class="body" style="margin-bottom:12px;">Conferente envia foto + descrição via WhatsApp para o número da operação. Bot Cláudio (Evolution API) cria divergência automática + foto anexada.</p>
        <div class="row gap-sm" style="margin-bottom:8px;">
          <span class="pill pill-mute" id="wa-status">dry-run · sem instância</span>
        </div>
        <p class="text-sm text-mute">Edge function <span class="mono-inline">binario-wms-wa-divergencia</span> pronta. Configure <span class="mono-inline">EVOLUTION_API_URL</span> + <span class="mono-inline">EVOLUTION_API_KEY</span> + <span class="mono-inline">EVOLUTION_INSTANCE</span> em Secrets para ativar webhook.</p>
      </div>
    </div>
  `;

  document.getElementById('div-filter').addEventListener('change', () => loadList());

  await Promise.all([loadStats(), loadList(), loadOrigens()]);

  async function loadStats() {
    const { data: all } = await db.from('divergencia').select('status,origem,data_evento');
    const abertas = (all || []).filter(d => d.status === 'aberta').length;
    const apurando = (all || []).filter(d => d.status === 'em_apuracao').length;
    const resolvidas = (all || []).filter(d => d.status === 'resolvida').length;
    const total = (all || []).length;
    const ult7d = (all || []).filter(d => new Date(d.data_evento) > new Date(Date.now() - 7 * 86400_000)).length;
    document.getElementById('div-stats').innerHTML = `
      <div class="stat ${abertas > 0 ? 'warning' : 'success'}"><div class="label">Abertas</div><div class="value">${NUM(abertas)}</div></div>
      <div class="stat ${apurando > 0 ? 'warning' : ''}"><div class="label">Em apuração</div><div class="value">${NUM(apurando)}</div></div>
      <div class="stat success"><div class="label">Resolvidas</div><div class="value">${NUM(resolvidas)}</div></div>
      <div class="stat"><div class="label">Últimos 7d</div><div class="value">${NUM(ult7d)}</div></div>
      <div class="stat"><div class="label">Total histórico</div><div class="value">${NUM(total)}</div></div>
    `;
  }

  async function loadList() {
    const f = document.getElementById('div-filter').value;
    let q = db.from('divergencia').select('*').order('data_evento', { ascending: false }).limit(80);
    if (f === 'abertas') q = q.in('status', ['aberta', 'em_apuracao']);
    else if (f !== 'todas') q = q.eq('status', f);
    const { data: rows, error } = await q;
    const el = document.getElementById('div-list');
    document.getElementById('div-count').textContent = (rows || []).length;
    if (error) { el.innerHTML = `<div class="empty err">${escapeHTML(error.message)}</div>`; return; }
    if (!rows || rows.length === 0) { el.innerHTML = '<div class="empty">Nenhuma divergência neste filtro.</div>'; return; }
    el.innerHTML = `
      <table class="tbl">
        <thead><tr><th>Quando</th><th>Origem</th><th>SKU</th><th>Descrição</th><th class="num">Esperado</th><th class="num">Real</th><th>Status</th><th>Foto</th><th></th></tr></thead>
        <tbody>${rows.map(d => `
          <tr>
            <td class="mono text-sm">${DT(d.data_evento)}</td>
            <td><span class="pill pill-mute">${escapeHTML(d.origem)}</span></td>
            <td class="mono">${escapeHTML(SHORT(d.sku_codigo || '—', 20))}</td>
            <td>${escapeHTML(SHORT(d.descricao || '', 38))}</td>
            <td class="num">${QTY(d.qtd_esperada)}</td>
            <td class="num">${QTY(d.qtd_real)}</td>
            <td><span class="pill ${pillStatus(d.status)}">${escapeHTML(d.status)}</span></td>
            <td>${d.foto_url ? `<a href="${escapeHTML(d.foto_url)}" target="_blank" class="text-mono text-sm">📷 ver</a>` : '<span class="text-mute text-sm">—</span>'}</td>
            <td><button class="btn-mini" data-edit="${d.id}">tratar →</button></td>
          </tr>`).join('')}
        </tbody>
      </table>`;
    el.querySelectorAll('[data-edit]').forEach(b => b.addEventListener('click', () => abrirTratar(parseInt(b.dataset.edit, 10))));
  }

  async function abrirTratar(id) {
    const card = document.getElementById('div-form-card');
    const body = document.getElementById('div-form-body');
    document.getElementById('div-form-title').textContent = `Divergência #${id}`;
    card.style.display = 'block';
    const { data: d } = await db.from('divergencia').select('*').eq('id', id).maybeSingle();
    if (!d) { body.innerHTML = '<div class="empty err">Não encontrada</div>'; return; }
    body.innerHTML = `
      <div class="grid-2 mb-md">
        <div><div class="kicker">SKU</div><div class="mono strong">${escapeHTML(d.sku_codigo || '—')}</div></div>
        <div><div class="kicker">ORIGEM</div><div><span class="pill pill-mute">${escapeHTML(d.origem)}</span></div></div>
        <div><div class="kicker">ESPERADO</div><div class="mono">${QTY(d.qtd_esperada)}</div></div>
        <div><div class="kicker">REAL</div><div class="mono">${QTY(d.qtd_real)}</div></div>
      </div>
      <div class="mb-md"><div class="kicker">DESCRIÇÃO ORIGINAL</div><div>${escapeHTML(d.descricao || '')}</div></div>
      <form id="form-trat" class="form-stack">
        <label>Status
          <select id="trat-status">
            <option value="aberta" ${d.status === 'aberta' ? 'selected' : ''}>aberta</option>
            <option value="em_apuracao" ${d.status === 'em_apuracao' ? 'selected' : ''}>em apuração</option>
            <option value="resolvida" ${d.status === 'resolvida' ? 'selected' : ''}>resolvida</option>
            <option value="descartada" ${d.status === 'descartada' ? 'selected' : ''}>descartada</option>
          </select>
        </label>
        <label>Causa raiz<textarea id="trat-causa" rows="2" placeholder="Por que a divergência aconteceu (root cause)">${escapeHTML(d.causa_raiz || '')}</textarea></label>
        <label>Ação corretiva<textarea id="trat-acao" rows="2" placeholder="O que vai garantir que não acontece de novo">${escapeHTML(d.acao_corretiva || '')}</textarea></label>
        <label>Responsável<input id="trat-resp" value="${escapeHTML(d.responsavel || '')}"></label>
        <label>URL da foto (opcional)<input id="trat-foto" value="${escapeHTML(d.foto_url || '')}" placeholder="https://…"></label>
        <div class="row gap-sm">
          <button type="submit" class="btn btn-blue">Salvar tratamento</button>
          <button type="button" class="btn-mini" id="trat-cancel">cancelar</button>
        </div>
      </form>
    `;
    document.getElementById('trat-cancel').addEventListener('click', () => card.style.display = 'none');
    document.getElementById('form-trat').addEventListener('submit', async (e) => {
      e.preventDefault();
      const status = document.getElementById('trat-status').value;
      const patch = {
        status,
        causa_raiz: document.getElementById('trat-causa').value || null,
        acao_corretiva: document.getElementById('trat-acao').value || null,
        responsavel: document.getElementById('trat-resp').value || null,
        foto_url: document.getElementById('trat-foto').value || null,
        resolvida_em: status === 'resolvida' ? new Date().toISOString() : null,
      };
      try {
        const { error } = await db.from('divergencia').update(patch).eq('id', id);
        if (error) throw error;
        card.style.display = 'none';
        viewDivergencias($c);
      } catch (err) { alert('Erro: ' + err.message); }
    });
  }

  document.getElementById('btn-close-div-form').addEventListener('click', () => document.getElementById('div-form-card').style.display = 'none');

  document.getElementById('btn-nova-div').addEventListener('click', () => {
    const card = document.getElementById('div-form-card');
    document.getElementById('div-form-title').textContent = 'Nova divergência manual';
    card.style.display = 'block';
    const body = document.getElementById('div-form-body');
    body.innerHTML = `
      <form id="form-nova" class="form-stack" style="max-width:720px;">
        <div class="grid-2">
          <label>Origem
            <select id="nv-origem" required>
              <option value="recebimento">Recebimento</option>
              <option value="expedicao">Expedição</option>
              <option value="inventario">Inventário</option>
              <option value="sistema">Sistema</option>
            </select>
          </label>
          <label>SKU<input id="nv-sku" placeholder="código"></label>
          <label>Qtd esperada<input id="nv-esp" type="number" step="0.01"></label>
          <label>Qtd real<input id="nv-real" type="number" step="0.01"></label>
          <label>Conferente<input id="nv-conf"></label>
          <label>Foto URL<input id="nv-foto"></label>
        </div>
        <label>Descrição (obrigatória)<textarea id="nv-desc" rows="2" required></textarea></label>
        <div class="row gap-sm">
          <button type="submit" class="btn btn-blue">Registrar</button>
          <button type="button" class="btn-mini" id="nv-cancel">cancelar</button>
        </div>
      </form>
    `;
    document.getElementById('nv-cancel').addEventListener('click', () => card.style.display = 'none');
    document.getElementById('form-nova').addEventListener('submit', async (e) => {
      e.preventDefault();
      try {
        await db.from('divergencia').insert({
          origem: document.getElementById('nv-origem').value,
          sku_codigo: document.getElementById('nv-sku').value || null,
          qtd_esperada: parseFloat(document.getElementById('nv-esp').value || '0') || null,
          qtd_real: parseFloat(document.getElementById('nv-real').value || '0') || null,
          conferente: document.getElementById('nv-conf').value || null,
          foto_url: document.getElementById('nv-foto').value || null,
          descricao: document.getElementById('nv-desc').value,
          status: 'aberta',
        });
        card.style.display = 'none';
        viewDivergencias($c);
      } catch (err) { alert('Erro: ' + err.message); }
    });
  });

  async function loadOrigens() {
    const { data } = await db.from('divergencia').select('origem');
    const counts = {};
    (data || []).forEach(d => { counts[d.origem] = (counts[d.origem] || 0) + 1; });
    document.getElementById('div-origins').innerHTML = `
      <table class="tbl">
        <thead><tr><th>Origem</th><th class="num">Total histórico</th></tr></thead>
        <tbody>${Object.entries(counts).map(([k, v]) =>
          `<tr><td><span class="pill pill-mute">${escapeHTML(k)}</span></td><td class="num">${NUM(v)}</td></tr>`
        ).join('') || '<tr><td colspan="2" class="empty">Sem dados</td></tr>'}</tbody>
      </table>
    `;
  }
}

function pillStatus(s) {
  return { aberta: 'pill-amber', em_apuracao: 'pill-blue', resolvida: 'pill-green', descartada: 'pill-mute' }[s] || 'pill-mute';
}
